import {Component, ComponentRef, Input, OnInit, Renderer2, signal} from '@angular/core';
import {HelpService} from "../help.service";
import {Observable} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {Router} from "@angular/router";
import {HelpModel} from "../help.model";
import {BaseComponent} from "../../base-component";
import {DomService} from "../../dom.service";

@Component({
  selector: 'app-help-sidebar',
  templateUrl: './help-sidebar.component.html',
  styles: [':host {overflow: auto; width: 25%; height: 100vh}'
  ]
})
export class HelpSidebarComponent extends BaseComponent implements OnInit {
  @Input() componentRef: ComponentRef<HelpSidebarComponent>;
  help$: Observable<HelpModel> = new Observable<HelpModel>();
  isLoading = signal(false);

  constructor(private renderer: Renderer2, private domService: DomService, public helpService: HelpService, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'help-open');
    this.subscribeToTopics();
  }

  ngOnDestroy() {
    this.domService.destroy(this.componentRef);
    this.renderer.removeClass(document.body, 'help-open');
  }

  close() {
    this.helpService.closeSidebar();
    this.ngOnDestroy();
  }

  subscribeToTopics() {
    this.helpService.topic$.pipe(map(topic => {
      this.isLoading.set(true);
      this.help$ = this.getHelp(topic);
    })).subscribe();
  }

  getHelp(key: string, insistCore: boolean = null) {
    return this.helpService.getHelp(key, insistCore).pipe(map(value => {
      this.isLoading.set(false);
      return value;
    }));
  }

  getBaseVersion(key: string) {
    this.isLoading.set(true);
    this.help$ = this.getHelp(key, true).pipe(takeUntil(this.componentDestroyed));
  }

  navigate(help: HelpModel, inEditMode: boolean = false) {
    this.helpService.isEditMode = inEditMode;
    this.router.navigate(['help', help.Id]);
  }
}
